import { useState } from "react";
import { Logo } from "@/components/site/Logo";
import { api, errorText } from "@/lib/api";

export default function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      onLogin(data);
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };

  const input = "w-full rounded-xl border border-white/15 bg-white/5 px-4 py-3 text-white placeholder:text-zinc-400 focus:border-white focus:outline-none";
  return (
    <div className="grid min-h-screen place-items-center px-5">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm rounded-[24px] border border-white/10 bg-[#14171E] p-8">
        <Logo testid="admin-login-logo" />
        <h1 className="mt-6 font-display text-3xl font-black uppercase italic">Panel administratora</h1>
        <div className="mt-6 space-y-3">
          <input data-testid="admin-login-email-input" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={input} />
          <input data-testid="admin-login-password-input" type="password" required placeholder="Hasło" value={password} onChange={(e) => setPassword(e.target.value)} className={input} />
        </div>
        {error && <p data-testid="admin-login-error" className="mt-3 text-sm text-red-400">{error}</p>}
        <button data-testid="admin-login-submit-button" disabled={busy} className="mt-6 w-full rounded-full bg-white py-3 font-semibold text-black hover:bg-zinc-300 disabled:opacity-60">
          {busy ? "Logowanie…" : "Zaloguj"}
        </button>
      </form>
    </div>
  );
}
